import React from 'react';
import { strategyRules } from '../data/strategy';
export function StrategyBreakdown() {
  return <section id="estrategia" className="border-b border-line" data-id="element-81" data-mp="yikspj17oex7">
      <div className="mx-auto w-full max-w-[1400px] px-6 py-20 lg:px-10 lg:py-24" data-id="element-82" data-mp="ylgp32xeuvjj">
        <div className="max-w-2xl" data-id="element-83" data-mp="tqksdph8bk03">
          <h2 className="text-2xl font-semibold tracking-tight text-white sm:text-3xl" data-id="element-84" data-mp="otklxdggwf8g">
            El Protocolo, en tres reglas.
          </h2>
          <p className="mt-3 text-[15px] leading-relaxed text-white/50" data-id="element-85" data-mp="ktak8czpkaze">
            Un sistema cerrado: sin criterio discrecional, sin excepciones. Cada
            regla define exactamente qué se observa y cuándo se ejecuta.
          </p>
        </div>

        <div className="mt-14 grid gap-px border-t border-line bg-line md:grid-cols-3" data-id="element-86" data-mp="5uoxyjv7cx32">
          {strategyRules.map(rule => <article key={rule.id} className="flex flex-col bg-ink px-0 pb-2 pt-8 md:px-8" data-id="element-87" data-mp="2569j8rxlt366">
              <div className="flex items-baseline justify-between" data-id="element-88" data-mp="206dbqipp6tlv">
                <span className="font-mono text-[12px] tracking-[0.2em] text-cyan-vip" data-id="element-89" data-mp="vh1v21q2fgq">
                  {rule.id}
                </span>
                <span className="font-mono text-[11px] tracking-[0.18em] text-white/30" data-id="element-90" data-mp="5t0fq0uicq85">
                  {rule.meta}
                </span>
              </div>
              <h3 className="mt-6 text-xl font-medium tracking-tight text-white" data-id="element-91" data-mp="3s3cssai3qazl">
                {rule.title}
              </h3>
              <p className="mt-3 text-[14px] leading-relaxed text-white/50" data-id="element-92" data-mp="jp43bbavm0bn">
                {rule.description}
              </p>
              <div className="mt-auto pt-8" data-id="element-93" data-mp="9xhwdr5kmnep">
                <span className="block h-px w-10 bg-gold-vip/60" data-id="element-94" data-mp="9wf35cks08vm" />
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}